/* Zielinski & Rozen page helpers: favourites (saved on device), size pills, small toggles */
(function () {
  var KEY = 'zrFav';
  var FR = (document.documentElement.lang || 'fr').slice(0, 2) === 'fr';
  function get() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function set(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function paint() {
    var a = get();
    document.querySelectorAll('[data-zr-fav]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-zr-fav')) > -1;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-zr-fav-count]').forEach(function (c) { c.textContent = a.length; c.hidden = !a.length; });
  }
  window.zrPaint = paint;

  function money(cents) {
    var fmt = window.zrMoneyFormat || '€{{amount_with_comma_separator}}';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function parts(title) {
    var t = title.replace(/^.*?ZIELINSKI (&|AND|&amp;) ROZEN - /i, '');
    var p = t.split(' - '), type = '', notes = t;
    if (p.length >= 3) { type = p[0] + ' ' + p[2]; notes = p[1]; } else if (p.length === 2) { type = p[0]; notes = p[1]; }
    return { notes: notes, type: type };
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function card(p) {
    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    var pt = parts(p.title), multi = p.variants.length > 1;
    var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
    var url = root().replace(/\/$/, '') + '/products/' + p.handle;
    var sizes = '';
    if (multi) {
      sizes = '<div class="zr-sizes">' + p.variants.map(function (x) {
        return '<button type="button" class="zr-size' + (x.id === v.id ? ' on' : '') + (x.available ? '' : ' so') + '" data-id="' + x.id + '" data-price="' + esc(money(x.price)) + '"' + (x.available ? '' : ' data-so') + '>' + esc(x.title.replace(' ML', ' ml')) + '</button>';
      }).join('') + '</div>';
    }
    var add = FR ? 'Ajouter au panier' : 'Add to cart', so = FR ? 'Épuisé' : 'Sold out';
    return '<div class="zr-gcard' + (p.available ? '' : ' so') + '" data-handle="' + esc(p.handle) + '">' +
      '<a class="img" href="' + url + '" tabindex="-1">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<button type="button" class="zr-heart on-card on" data-zr-fav="' + esc(p.handle) + '" aria-pressed="true" aria-label="' + (FR ? 'Retirer des favoris' : 'Remove from favourites') + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.4s-7.6-4.6-9.4-9.3C1.3 7.6 3.6 4.3 7.1 4.3c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.5 0 5.8 3.3 4.5 6.8-1.8 4.7-9.4 9.3-9.4 9.3z"/></svg></button>' +
      '<a class="body" href="' + url + '"><span class="t">' + esc(pt.notes) + '</span><span class="rule"></span><span class="m"><span class="s">' + esc(pt.type) + '</span><span class="p" data-zr-price>' + esc(money(v.price)) + '</span></span></a>' +
      '<div class="buy">' + sizes +
      '<product-form class="product-form zr-pf"><form method="post" action="' + root().replace(/\/$/, '') + '/cart/add" class="form" novalidate data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="' + v.id + '">' +
      '<button type="submit" name="add" class="zr-btn zr-add" data-add="' + add + '" data-so="' + so + '"' + (v.available ? '' : ' disabled') + '><span>' + (v.available ? add : so) + '</span><span class="sold-out-message hidden">' + so + '</span></button><div class="loading-overlay__spinner hidden"></div></form></product-form>' +
      '</div></div>';
  }

  function panel() { return document.getElementById('zr-favs'); }
  function render() {
    var pn = panel(); if (!pn) return;
    var grid = pn.querySelector('[data-zr-favs-grid]'), a = get();
    if (!a.length) { grid.innerHTML = '<p class="zr-favs-empty">' + (FR ? 'Aucun favori pour le moment.' : 'No favourites yet.') + '</p>'; return; }
    grid.innerHTML = '<p class="zr-favs-empty">…</p>';
    Promise.all(a.map(function (h) {
      return fetch(root().replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      var html = list.filter(Boolean).map(card).join('');
      grid.innerHTML = html || '<p class="zr-favs-empty">' + (FR ? 'Aucun favori pour le moment.' : 'No favourites yet.') + '</p>';
    });
  }
  function togglePanel(force) {
    var pn = panel(); if (!pn) return;
    var open = typeof force === 'boolean' ? force : pn.hidden;
    pn.hidden = !open;
    document.querySelectorAll('[data-zr-fav-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); b.classList.toggle('on', open && b.classList.contains('fav')); });
    if (open) { render(); pn.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-zr-fav]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var h = b.getAttribute('data-zr-fav'), a = get(), i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.unshift(h);
      set(a); paint();
      b.classList.add('pop'); setTimeout(function () { b.classList.remove('pop'); }, 350);
      var pn = panel(); if (pn && !pn.hidden && i > -1) { var c = b.closest('.zr-favs .zr-gcard'); if (c) c.remove(); }
      return;
    }
    var s = e.target.closest('.zr-size');
    if (s) {
      e.preventDefault();
      var cardEl = s.closest('.zr-gcard') || s.closest('.zr-card') || s.closest('.zrp-buy');
      if (!cardEl) return;
      if (s.dataset.img && !cardEl.classList.contains('zrp-buy')) { var ci = cardEl.querySelector('.img img'); if (ci) { ci.removeAttribute('srcset'); ci.src = s.dataset.img; } }
      cardEl.querySelectorAll('.zr-size').forEach(function (x) { x.classList.toggle('on', x === s); });
      var inp = cardEl.querySelector('input[name=id]'); if (inp) inp.value = s.getAttribute('data-id');
      var pr = cardEl.querySelector('[data-zr-price]'); if (pr) pr.innerHTML = s.getAttribute('data-price');
      var btn = cardEl.querySelector('.zr-add');
      if (btn) { var so = s.hasAttribute('data-so'); btn.disabled = so; btn.removeAttribute('aria-disabled'); btn.querySelector('span').textContent = so ? btn.getAttribute('data-so') : btn.getAttribute('data-add'); }
      return;
    }
    var t = e.target.closest('[data-zr-fav-toggle]');
    if (t) { e.preventDefault(); togglePanel(); return; }
    var g = e.target.closest('[data-zr-toggle]');
    if (g) {
      e.preventDefault();
      var el = document.getElementById(g.getAttribute('data-zr-toggle'));
      if (el) { el.hidden = !el.hidden; g.setAttribute('aria-expanded', el.hidden ? 'false' : 'true'); }
    }
  });

  var tm;
  function init() {
    paint();
    if ('MutationObserver' in window) new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(paint, 120); }).observe(document.body, { childList: true, subtree: true });
    if (location.hash === '#zr-favoris') togglePanel(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
